module.exports = __webpack_public_path__ + "img/defkf.782dd551.png";